// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/types';

export const getSelectedInsuranceID = (state: ReduxStateShared) => state.insurances.selectedInsuranceID;
